module.exports = __webpack_public_path__ + "static/media/breakfast.babd821c.jpg";